import styled from 'styled-components';

export const Overlay = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
`;

/**
 * Sized to content up to 90vh, like legacy's help popup; the two panes carry
 * their own caps below. The real help content is far larger than a small fixed
 * height allows.
 */
export const ModalContainer = styled.div`
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-width: 900px;
  overflow: hidden;
  position: relative;
  width: 80vw;
`;

export const ModalHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--grey-300);
  box-shadow: 0 2px 10px rgba(34, 34, 34, 0.1);
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 12px;
  position: relative;
`;

export const ModalTitle = styled.h2`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.7px;
  margin: 0;
  text-transform: uppercase;
`;

export const ModalBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const SideNav = styled.nav`
  background: var(--grey-150);
  border-right: 1px solid var(--grey-500);
  flex-shrink: 0;
  /* .popup-scroll -- assets/scss/plugins/_magnific-popup.scss:318-321 */
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px 0 32px 20px;
  width: 200px;
`;

export const SideNavCategory = styled.p`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.7px;
  margin: 0;
  padding-bottom: 14px;
  text-transform: uppercase;

  &:first-child {
    padding-top: 4px;
  }
`;

export const SideNavItem = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  color: ${({ $active }) => ($active ? 'var(--wbs-red)' : 'var(--grey-700)')};
  cursor: pointer;
  display: block;
  font-family: var(--raleway);
  font-size: 15px;
  font-weight: ${({ $active }) => ($active ? '600' : '400')};
  padding: 0px 0px 14px 20px;

  text-align: left;
  transition: color 0.12s ease;
  width: 100%;

  &:hover {
    color: var(--wbs-red);
  }
`;

export const ContentArea = styled.div`
  background: var(--grey-50);
  flex: 1;
  font-family: var(--open-sans);
  font-size: 14px;
  line-height: 1.6;
  /* .contextual-helps-body -- _contextual-helps.scss:80-84 */
  max-height: 53vh;
  min-width: 0;
  overflow-y: auto;
  padding: 28px 36px;

  h1,
  h2,
  h3 {
    font-family: var(--raleway);
  }

  p {
    font-family: var(--raleway);
    font-size: 16px;
    margin: 0 0 12px;
  }

  a {
    color: var(--blue);
  }
`;
